<main class="container my-4" role="main" aria-label="Search History">
  <div class="div-main">
    <div class="card-wrap">
      <div class="d-flex wrap-backbutton">
        <button class="btn back-btn" type="button" (click)="goBack()" aria-label="Back to previous screen">
          <i class="bi bi-arrow-left-circle icon fs-4 btn-icon"></i>{{constants.BACK}}
        </button>
      </div>
      <div class="div-head">
        <div class="div-title" id="search-history-title">
          {{constants.SEARCH_PROFILE.SEARCH_HISTORY}}
        </div>
        <mat-paginator #historyPaginator [length]="totalItems" [pageSize]="pageSize"
          [pageSizeOptions]="[5, 10, 25, 100]" (page)="onPageChangeCR($event)">
        </mat-paginator>
      </div>
      <div class="div-profiles card-custom">
        <table mat-table [dataSource]="dataSource" matSort #sortHi="matSort" class="profiles-table mat-table-sticky" matSortDisableClear aria-labelledby="search-history-title">
          <caption class="visually-hidden">User Search History Table</caption>
          <ng-template ngFor let-col [ngForOf]="displayedColumns">
            <ng-container [matColumnDef]="col" *ngIf="(col==='action'); else elseblock">
              <th mat-header-cell *matHeaderCellDef [class]="['action','search_date','rcm_id'].includes(col)?'sticky-column':''" scope="col">
                {{col | displayColName}}
              </th>
              <td mat-cell *matCellDef="let element" [class]="['action','search_date','rcm_id'].includes(col)?'sticky-column css_td_{{col}}':'css_td_{{col}}'">
                <button (click)="performSearch(element)" class="btn-search-his">
                  Search<i class="bi bi-chevron-right icon fs-4 btn-icon"></i>
                </button>
              </td>
            </ng-container>
            <ng-template #elseblock>
              <ng-container [matColumnDef]="col">
                <th mat-header-cell *matHeaderCellDef [class]="['action','search_date','rcm_id'].includes(col)?'sticky-column':''"
                  [mat-sort-header]="col" scope="col">
                  {{col | displayColName}}
                </th>
                <td mat-cell *matCellDef="let element" [class]="['action','search_date','rcm_id'].includes(col)?'sticky-column css_td_{{col}}':'css_td_{{col}}'">
                  <span *ngIf="(col==='search_date');else elseblockcol">{{element[col] | convertUtc}}</span>
                  <ng-template #elseblockcol><span>{{element[col]}}</span></ng-template>
                </td>
              </ng-container>
            </ng-template>
          </ng-template>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
           <!-- No Data Row -->
          <tr class="mat-row" *matNoDataRow>
            <td
              class="mat-cell no-data-available"
              [attr.colspan]="displayedColumns.length"
            >
              No data available
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</main>
